import { useDoesReportingMonetizationApply } from '@cast/shared-trial-ui';

import { getRemainingRecommendedCount } from './_utils';
import { useOnboardingWizardTasks } from './useOnboardingWizardTasks';

export const shouldShowGettingStartedHelpEntry = ({
  isLoading,
  monetizationApplies,
  remainingRecommendedCount,
}: {
  isLoading: boolean;
  monetizationApplies: boolean;
  remainingRecommendedCount: number;
}): boolean =>
  !isLoading && monetizationApplies && remainingRecommendedCount > 0;

/**
 * Help → Getting started is shown only while Cast Radar onboarding is
 * incomplete (progress under 100%).
 */
export const useShouldShowGettingStartedHelpEntry = (): boolean => {
  const { tasks, isLoading } = useOnboardingWizardTasks();
  const monetizationApplies = useDoesReportingMonetizationApply();

  return shouldShowGettingStartedHelpEntry({
    isLoading,
    monetizationApplies,
    remainingRecommendedCount: getRemainingRecommendedCount(tasks),
  });
};
